<template>
  <div
    class="relative inline-flex gap-[2px] h-4 shrink-0"
    role="img"
    :aria-label="`Рейтинг ${rating} из 5`"
  >
    <svg
      v-for="index in 5"
      :key="`empty-${index}`"
      width="16"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="shrink-0"
      aria-hidden="true"
    >
      <path
        :d="emptyStarPath"
        stroke="#D1D1D1"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <div
      class="absolute left-0 top-0 flex gap-[2px] h-4 overflow-hidden"
      :style="{ width: `${fillWidth}px` }"
      aria-hidden="true"
    >
      <svg
        v-for="index in 5"
        :key="`full-${index}`"
        width="16"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="shrink-0"
      >
        <path
          :d="fullStarPath"
          fill="#FDBC15"
          fill-rule="evenodd"
          clip-rule="evenodd"
        />
      </svg>
    </div>
  </div>
</template>

<script setup>
const STAR_SIZE = 16
const STAR_GAP = 2

const emptyStarPath = 'M8.24533 0.867997L8.24545 0.868037L8.2496 0.854888C8.25919 0.824466 8.27823 0.797894 8.30396 0.779031C8.32968 0.760169 8.36075 0.75 8.39265 0.75C8.42455 0.75 8.45562 0.76017 8.48135 0.779031C8.50707 0.797894 8.52611 0.824466 8.53571 0.854888L8.53568 0.854897L8.53775 0.861254L10.0877 5.62792C10.1882 5.93685 10.4761 6.14599 10.801 6.14599H15.801C15.8104 6.14599 15.8199 6.14581 15.8293 6.14546C15.8639 6.14415 15.8979 6.15419 15.9262 6.17405C15.9545 6.19391 15.9756 6.22249 15.9861 6.25542C15.9966 6.28836 15.9961 6.32384 15.9846 6.35644C15.9731 6.38904 15.9512 6.41698 15.9223 6.43598C15.9128 6.44224 15.9034 6.44872 15.8942 6.45541L11.8358 9.39707C11.5726 9.5879 11.4622 9.92662 11.5626 10.2359L13.1126 15.0109L13.1126 15.0109L13.1153 15.0189C13.1255 15.0492 13.1257 15.082 13.116 15.1124C13.1063 15.1429 13.087 15.1695 13.0611 15.1882C13.0352 15.207 13.004 15.217 12.972 15.2168C12.94 15.2165 12.9089 15.2061 12.8833 15.1869L12.8833 15.1869L12.8771 15.1823L8.81048 12.2073C8.54745 12.0149 8.19028 12.0144 7.92667 12.206L3.86834 15.156L3.8683 15.1559L3.86032 15.1619C3.8347 15.1811 3.80362 15.1915 3.77163 15.1918C3.73964 15.192 3.70841 15.182 3.68251 15.1632C3.6566 15.1445 3.63738 15.1179 3.62764 15.0874C3.6179 15.057 3.61816 15.0242 3.62837 14.9939L3.62842 14.9939L3.63101 14.9859L5.18101 10.2109C5.2814 9.90162 5.17108 9.5629 4.90782 9.37207L0.849483 6.43041C0.840254 6.42372 0.830873 6.41724 0.821349 6.41098C0.792454 6.39198 0.770574 6.36404 0.75905 6.33144C0.747526 6.29884 0.746994 6.26336 0.757533 6.23042C0.768072 6.19749 0.789104 6.16891 0.817415 6.14905C0.845725 6.12919 0.879759 6.11915 0.914315 6.12046C0.923757 6.12081 0.933204 6.12099 0.942652 6.12099H5.94265C6.26489 6.12099 6.55112 5.91515 6.65366 5.60966L8.24533 0.867997Z'

const fullStarPath = 'M7.53432 0.629327C7.59188 0.446791 7.70614 0.287359 7.86049 0.174188C8.01484 0.0610169 8.20125 0 8.39265 0C8.58405 0 8.77046 0.0610169 8.92481 0.174188C9.07917 0.287359 9.19342 0.446791 9.25099 0.629327L10.801 5.39599H15.801C15.9992 5.3885 16.1945 5.44611 16.3569 5.56002C16.5193 5.67394 16.64 5.83789 16.7004 6.02684C16.7609 6.21578 16.7578 6.41933 16.6917 6.60637C16.6256 6.79342 16.5001 6.95367 16.3343 7.06266L12.276 10.0043L13.826 14.7793C13.8873 14.9612 13.8888 15.1579 13.8304 15.3408C13.772 15.5236 13.6566 15.683 13.5012 15.7956C13.3457 15.9082 13.1584 15.9682 12.9664 15.9667C12.7745 15.9653 12.5881 15.9026 12.4343 15.7877L8.36765 12.8127L4.30932 15.7627C4.15558 15.8776 3.96912 15.9403 3.77719 15.9417C3.58525 15.9432 3.39789 15.8832 3.24246 15.7706C3.08703 15.6579 2.97168 15.4986 2.91324 15.3158C2.85481 15.1329 2.85635 14.9362 2.91765 14.7543L4.46765 9.97933L0.409318 7.03766C0.243554 6.92867 0.118028 6.76842 0.0519188 6.58137C-0.0141905 6.39433 -0.0172475 6.19078 0.0432148 6.00184C0.103677 5.8129 0.224334 5.64894 0.38675 5.53502C0.549166 5.42111 0.74441 5.3635 0.942652 5.37099H5.94265L7.53432 0.629327Z'

const props = defineProps({
  rating: {
    type: Number,
    default: 0,
  },
  id: {
    type: [String, Number],
    default: undefined,
  },
})

const fillWidth = computed(() => {
  const value = Math.min(5, Math.max(0, props.rating))
  const wholeStars = Math.floor(value)
  const fraction = value - wholeStars

  let width = wholeStars * STAR_SIZE + Math.max(0, wholeStars - 1) * STAR_GAP

  if (fraction > 0) {
    width += STAR_GAP + fraction * STAR_SIZE
  }

  return width
})
</script>
